module.exports = __webpack_public_path__ + "img/banner.757d7fb1.jpg";